function blog(args) {
  return "blog";
}

export { blog };
